/* eslint-disable max-lines-per-function */
import React from "react";
import { Grid } from "@mui/material";
import { TemplateSelector } from "components/send-messages/template-selector";
import { TemplateForm } from "components/send-messages";
import { Viewer } from "components/auth/types";
import { Delta } from "components/message-editor/types";
import { calculateMessageValues } from "utils/template";
import ErrorMessage from "components/error-message";
import {
  getTemplateGroup_templateGroup as Template,
  QueryInterestProfile_interest as InterestType,
} from "types/gql-types";
import { getLanguageNameByCode } from "../utils";
import styles from "./batchActions.module.css";

export type SendMessageStateValues = {
  emailEnabled: boolean;
  emailBody: Delta;
  emailSubject: string;
  emailBccAddress: string;
  emailRespondToEnabled: boolean;
  letterEnabled: boolean;
  letterBody: Delta;
  smsEnabled: boolean;
  smsBody: Delta;
  smsPropertyUseCaseId: string | null;
}


type Props = {
  interest: InterestType;
  interestListID: string;
  viewer: Viewer;
  onChange: (param: SendMessageStateValues) => void;
  isShowing: boolean;
  errorMessages: { form: string; email: string; sms: string; letter: string };
  fieldErrors: { emailSubject: string; smsUseCase: string };
}

const MessageForm: React.FC<Props> = ({
  interest,
  interestListID,
  viewer,
  onChange,
  isShowing,
  errorMessages,
  fieldErrors,
}) => {

  const [template, setTemplate] = React.useState<Template | null>(null);
  const updateValues = calculateMessageValues(template);

  let firstName = interest.applicantFirstName || interest.householdMember0FirstName;
  let lastName = interest.applicantLastName || interest.householdMember0LastName;
  if (!firstName && !lastName) {
    firstName = "N/A";
    lastName = "";
  }

  return (
    <>
      <Grid size={{ xs: 12 }} className={isShowing ? "" : styles.hideView}>
        <div className={styles.actionViewLabel}>Send a Message</div>
        {interest.prefLang && interest.prefLang !== "en" && (
          <span className="badge hc-badge">
            {getLanguageNameByCode(interest.prefLang)}
          </span>
        )}
      </Grid>
      <TemplateSelector
        onChange={(selectedTemplate: Template | null) => {
          if (selectedTemplate) setTemplate(selectedTemplate);
        }}
        viewer={viewer}
        currentTemplate={template}
        className={isShowing ? "" : styles.hideView}
      />
      <hr className={isShowing ? "" : styles.hideView} />
      <Grid size={{ xs: 12 }} className={isShowing ? "" : styles.hideView}>
        <TemplateForm
          viewer={viewer}
          isSending={false}
          template={template}
          onRequestClose={() => setTemplate(null)}
          currentListId={interestListID}
          {...updateValues}
          isHidingSubmitBtns
          onChange={onChange}
          errorMessages={{
            ...errorMessages,
            emailSubject: fieldErrors.emailSubject,
            smsUseCase: fieldErrors.smsUseCase,
          }}
        />
        <ErrorMessage errorMsg={errorMessages.form}/>
      </Grid>
    </>
  );
};
export default MessageForm;
